import {TabView} from 'components/LayoutOptions/layoutOptionsStyles';
import Split from 'react-split';
import styled from 'styled-components'

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
`

export const Option = styled.div`
    display: flex;
    color: white;
    justify-content:center;
    font-size: 48px;
    cursor: pointer;
    margin-bottom: 20px;

    :hover {
        filter: brightness(95%);
    }

`;

export const HorizontalSplit = styled(Split)`
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;
    max-width: 100vw;
	height: 100%;

    & > .gutter {
        position: relative;
        height: 120px;
        align-self: center;
        border-radius: 10px;
        background-color: rgb(124, 190, 123);
        background-repeat: no-repeat;
        background-position: 50%;

        :hover {
          cursor: col-resize;
        }
    }
`

export const TableWrap = styled(TabView)`
    position: relative;
    background: inherit;
    border: none;
    border-radius: unset;
    font-size: 48px;
    line-height: initial;
    display: flex;
    align-items: flex-start;
    width: 100%;
    height: 100%;
`;

export const MultipleTablesWrap = styled(Option)`
    width: 100%;
    height: 100%;

    :hover {
        filter: none;
    }
`;

export const VerticalSplit = styled(Split)`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 5px;
    width: 100%;
    height: 100%;

    & > .gutter {
        position: relative;
        width: 120px;
        align-self: center;
        vertical-align: middle;
        border-radius: 10px;
        background-color: rgb(124, 190, 123);
        background-repeat: no-repeat;
        background-position: 50%;

        :hover {
          cursor: row-resize;
        }
    }
`
